var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTfFrenchSouthernTerritories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_24134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#002395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H32.55V18.45H60V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H51V18H60V0Z",
    fill: "#002395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 0H33V18H42V0Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0625 20.5879L18.6188 22.8941H14.4938V30.9379L17.5875 26.1004L21.75 32.7379H19.725L17.5875 28.9129L13.2 36.7879L8.8125 28.9129L6.675 32.7379H4.65L8.8125 26.1004L11.9062 30.9379V26.4941H10.05L8.67188 24.3004H11.9062V22.8941H7.78125L6.3375 20.5879H20.0625ZM15.225 30.4316H19.725V32.0066H15.225V30.4316ZM6.675 30.4316H11.175V32.0066H6.675V30.4316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2002 38.3623L11.8164 42.6373L15.4502 39.9936H10.9502L14.5839 42.6373L13.2002 38.3623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2627 34.5371L16.8789 38.8121L20.5127 36.1684H16.0127L19.6464 38.8121L18.2627 34.5371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1377 34.5371L6.75395 38.8121L10.3877 36.1684H5.8877L9.52145 38.8121L8.1377 34.5371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5371 23.1748L21.1534 27.4498L24.7871 24.8061H20.2871L23.9209 27.4498L22.5371 23.1748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8623 23.1748L2.47855 27.4498L6.1123 24.8061H1.6123L5.24605 27.4498L3.8623 23.1748Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_24134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfFrenchSouthernTerritories);
export default __webpack_public_path__ + "static/media/tf French Southern Territories.6af1280eaf1e2b877b13914179ce4049.svg";
export { ForwardRef as ReactComponent };